module.exports = "/virtual-football-league/img/ticket-vfl-bar.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/ticket-vfl-bar.png
// module id = 331
// module chunks = 4